<template>
    <div class="CanvasPresentation">
        <CanvasPage v-for="canvasPage in canvasPages" :key="canvasPage.id" :canvas="canvasPage.canvas" :id="canvasPage.id" :page="canvasPage.page" v-show="canvasPage.page == page"></CanvasPage>
    </div>
</template>

<script>
    import CanvasPage from './CanvasPage.vue';

    export default {
        name: 'CanvasPresentation',
        props: {
            canvasPages: { required: true, type: Array, },
            id: { required: true, type: String, },
            page: { type: Number, default: 1}, 
        },
        components: {
            CanvasPage,
        },
    };
</script>

<style scoped>
    .CanvasPresentation {
        width: 100%;
        height: 100%;
    }
</style>